import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { ChevronRightIcon } from '@heroicons/react/20/solid';

const breadcrumbNameMap = {
  'products': 'Tüm Ürünler',
  'my-account': 'Hesabım',
  'my-orders': 'Siparişlerim',
  'cart': 'Sepetim',
  'checkout': 'Siparişi Tamamla',
  'favorites': 'Favorilerim',
  'about': 'Hakkımızda',
};

const Breadcrumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  if (pathnames.length === 0) {
    return null; // Ana sayfada breadcrumb gösterme
  }

  return (
    <nav className="flex mb-6" aria-label="Breadcrumb">
      <ol className="inline-flex items-center space-x-1 md:space-x-3">
        <li className="inline-flex items-center">
          <Link to="/" className="inline-flex items-center text-sm font-medium text-gray-700 hover:text-brand-green">
            Ana Sayfa
          </Link>
        </li>
        {pathnames.map((value, index) => {
          const to = `/${pathnames.slice(0, index + 1).join('/')}`;
          const isLast = index === pathnames.length - 1;
          // ID'leri veya anlamsız yolları göstermemek için basit bir kontrol
          if (value.length > 20) return null;

          return (
            <li key={to}>
              <div className="flex items-center">
                <ChevronRightIcon className="h-5 w-5 text-gray-400" />
                <Link
                  to={to}
                  className={`ml-1 text-sm font-medium ${isLast ? 'text-gray-500' : 'text-gray-700 hover:text-brand-green'}`}
                  aria-current={isLast ? 'page' : undefined}
                >
                  {breadcrumbNameMap[value] || value.charAt(0).toUpperCase() + value.slice(1)}
                </Link>
              </div>
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;